// Generated by ts-to-zod
import {z} from "zod";
import {mantineCssStyleRecordSchema} from "./primitives.zod";

export const mantineBadgePropsSchema = z.object({
	style: mantineCssStyleRecordSchema.optional(),
});
